import classNames from 'classnames'
import { OnScreenComponent } from 'components/abstract/OnScreenComponent'
import { Button } from 'components/common/Button'
import { Icon } from 'components/common/Icon'
import { useAuthModal } from 'contexts'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import { titleCase } from 'utils/strings'

const benefits = [
  'view_upcoming_releases',
  'set_email_reminders',
  'entries_updated_daily',
]

const artists = [
  { name: 'Damien Hirst', image: 'damien-hirst.png' },
  { name: 'Tracey Emin', image: 'tracey-emin.png' },
  { name: 'Banksy', image: 'banksy.png' },
  { name: 'Ayako Rokkaku', image: 'rokkaku.png' },
  { name: 'David Shrigley', image: 'david-shrigley.png' },
]

export const NeverMissAReleaseAgain = () => {
  const { t } = useTranslation('release_calendar')
  const { setIsOpen, setState } = useAuthModal()

  return (
    <section className='mx-auto w-full max-w-[90rem]'>
      <div className='w-full bg-purple-400 px-6 py-10 text-center text-cool-50 lg:px-12 [@media(min-width:90rem)]:mb-10 [@media(min-width:90rem)]:rounded-lg'>
        <h2 className='mb-6 font-body text-base font-normal tracking-normal text-cool-50 lg:mb-4 lg:text-2xl lg:text-xl'>
          {t('never_miss_a_release_again_cta')}
        </h2>

        <h3 className='mb-6 font-body text-2xl font-normal tracking-normal text-cool-50 lg:mb-4 lg:text-3xl'>
          <Trans
            i18nKey='release_calendar:create_a_free_account_now'
            components={{
              b: (
                <b className='mx-auto block w-max rounded bg-purple-500 px-2.5 font-normal sm:inline'></b>
              ),
            }}
          />
        </h3>

        <ol className='flex flex-col items-center space-y-4 lg:flex-row lg:justify-center lg:space-x-6 lg:space-y-0'>
          {benefits.map(benefit => (
            <li
              key={benefit}
              className='flex items-center space-x-2 text-center'
            >
              <Icon name='check' size={24} className='text-emerald-600' />

              <h4 className='font-body text-base font-normal tracking-normal text-cool-200'>
                {t(benefit)}
              </h4>
            </li>
          ))}
        </ol>

        <div className='mt-10 flex flex-row justify-center space-x-4'>
          <Button
            style='solid-white'
            pill
            size='xl'
            className='w-full !text-lg lg:w-[12.5rem]'
            onClick={() => {
              setState('register')
              setIsOpen(true)
            }}
          >
            {t('common:sign_up')}
          </Button>

          <Button
            style='outline'
            pill
            className='w-full !text-lg !text-cool-50 lg:w-[12.5rem]'
            size='xl'
            onClick={() => {
              setState('login')
              setIsOpen(true)
            }}
          >
            {titleCase(t('common:log_in'))}
          </Button>
        </div>

        <div className='mt-10'>
          <h5 className='font-body text-base font-normal tracking-normal text-cool-50 lg:text-2xl lg:text-xl'>
            {t('discover_releases_by_these_artists')}
          </h5>

          <ul className='mt-6 flex items-center justify-center space-x-4'>
            {artists.map((artist, index) => (
              <li
                key={artist.name}
                className={classNames(
                  'flex flex-col items-center justify-center space-y-3',
                  {
                    'hidden sm:flex': index === 3,
                    'hidden lg:flex': index === 4,
                  }
                )}
              >
                {artist.image && (
                  <OnScreenComponent className='relative flex h-24 w-24 sm:h-32 sm:w-32 lg:h-[8.75rem] lg:w-[8.75rem] [@media(max-width:339px)]:h-[4.625rem] [@media(max-width:339px)]:w-[4.625rem]'>
                    <Image
                      src={`/files/release-calendar/${artist.image}`}
                      alt={artist.name}
                      fill
                      className='rounded-full'
                      sizes='33vw, (min-width:640px) 25vw, (min-width:1024px) 20vw'
                      priority={false}
                      loading='lazy'
                    />
                  </OnScreenComponent>
                )}

                <h6 className='font-body text-xs font-normal text-cool-200'>
                  {artist.name}
                </h6>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
